import AuthContainer from '../../../containers/AuthContainer';
const useAuth = () => AuthContainer.get();
export default useAuth;